import DraggableThumb from '../draggable_thumb_controller';

export default class extends DraggableThumb {
  static values = {
    font: String,
    text: String,
  };

  createGhostElement() {
    const element = document.createElement('div');

    const text = document.createElement('p');
    text.style.fontFamily = this.fontValue;
    text.classList.add('text-5xl');
    text.innerHTML = 'Aa';
    element.append(text);

    return element;
  }

  addItem(itemProps) {
    itemProps['kind'] = 'text';
    window.ed.featureActionsService.add('text_added_to_canvas');
    itemProps['tiptapContent'] = this.#formattedText();
    itemProps['selectAll'] = true;

    return super.addItem(itemProps);
  }

  #formattedText() {
    return {
      type: 'doc',
      content: [
        {
          type: 'heading',
          attrs: {
            textAlign: 'center',
            level: 3,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'textStyle',
                  attrs: {
                    fontFamily: this.fontValue,
                    fontSize: '32pt',
                    color: '#000000',
                    lineHeight: 1,
                  },
                },
              ],
              text: this.textValue,
            },
          ],
        },
      ],
    };
  }
}
